import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class DeliveryChecker extends ThemeComponent {
    @Ref form!: HTMLFormElement;
    @Ref postcodeInput!: HTMLInputElement;

    private _onFormSubmit = new SimpleEvent<string>();
    public get onFormSubmit() {
        return this._onFormSubmit.asEvent();
    }

    init() {
        this.$listen(this.form, 'submit', (e) => {
            e.preventDefault();

            const userInputField = this.postcodeInput.value;
            this._onFormSubmit.dispatch(userInputField);
        });

    }
}
